import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { AccountInterface } from '@interface/account/account.interface';
import { ResponseDataInterface } from '@interface/logs/response-data.interface';
import { baseReducerActions } from '@util/data/base-reducer-actions';
import { mapifyPayload } from '@util/store/mapify-payload';

import { initialAccountsState } from './accounts.initial-state';

export const accountsSlice = createSlice({
  name: 'accounts',
  initialState: initialAccountsState,
  reducers: {
    ...baseReducerActions(initialAccountsState),
    setData: (state, { payload }: PayloadAction<ResponseDataInterface<AccountInterface[]>>) => {
      state.data = mapifyPayload(payload.data);
    },
    setCurrentAccount: (state, { payload }: PayloadAction<string>) => {
      state.meta.currentId = payload ?? '';
    },
    setCurrentAccountUsage: (state, { payload }: PayloadAction<ResponseDataInterface<{ usageQuantity: string }>>) => {
      state.meta.usageQuantity = payload.data.usageQuantity ?? '';
    },
  },
});

export const accountsActions = accountsSlice.actions;
